export default __webpack_public_path__ + "static/media/tab_2.3038a2d5.svg";